import templatePreview from "../../assets/remarkable.png";
let remarkableImg = window.wpmNotificationPluginBuildUrl + templatePreview;
const downloadId = "602";

const remarkable = [
  {
    id: "remarkable_wp-signup-admin",
    image: remarkableImg,
    label: "remarkable",
    category: "wp-signup-admin",
    downloadId,
  },
  {
    id: "remarkable_wp-signup-user",
    image: remarkableImg,
    label: "remarkable",
    category: "wp-signup-user",
    downloadId,
  },
  {
    id: "remarkable_wp-lost-password-admin",
    image: remarkableImg,
    label: "remarkable",
    category: "wp-lost-password-admin",
    downloadId,
  },
  {
    id: "remarkable_wp-lost-password-user",
    image: remarkableImg,
    label: "remarkable",
    category: "wp-lost-password-user",
    downloadId,
  },
  {
    id: "remarkable_wp-password-changed-user",
    image: remarkableImg,
    label: "remarkable",
    category: "wp-password-changed-user",
    downloadId,
  },
  {
    id: "remarkable_wp-change-user-email-user",
    image: remarkableImg,
    label: "remarkable",
    category: "wp-change-user-email-user",
    downloadId,
  },
  {
    id: "remarkable_wp-changed-user-email-user",
    image: remarkableImg,
    label: "remarkable",
    category: "wp-changed-user-email-user",
    downloadId,
  },
  {
    id: "remarkable_wp-comment-in-moderation-admin",
    image: remarkableImg,
    label: "remarkable",
    category: "wp-comment-in-moderation-admin",
    downloadId,
  },
  {
    id: "remarkable_wp-comment-published-post-author",
    image: remarkableImg,
    label: "remarkable",
    category: "wp-comment-published-post-author",
    downloadId,
  },
  {
    id: "remarkable_wp-change-site-admin-email",
    image: remarkableImg,
    label: "remarkable",
    category: "wp-change-site-admin-email",
    downloadId,
  },
  {
    id: "remarkable_wp-changed-site-admin-email",
    image: remarkableImg,
    label: "remarkable",
    category: "wp-changed-site-admin-email",
    downloadId,
  },
  {
    id: "remarkable_wp-request-personal-data-user",
    image: remarkableImg,
    label: "remarkable",
    category: "wp-request-personal-data-user",
    downloadId,
  },
  {
    id: "remarkable_wp-confirmed-personal-data-request-admin",
    image: remarkableImg,
    label: "remarkable",
    category: "wp-confirmed-personal-data-request-admin",
    downloadId,
  },
  {
    id: "remarkable_wp-download-personal-data-user",
    image: remarkableImg,
    label: "remarkable",
    category: "wp-download-personal-data-user",
    downloadId,
  },
  {
    id: "remarkable_wp-erased-personal-data-user",
    image: remarkableImg,
    label: "remarkable",
    category: "wp-erased-personal-data-user",
    downloadId,
  },
];
export default remarkable;
